<template>
    <div class="results">
        <audio src=""
               ref="audioPlayer"
               autoplay>
            Your browser does not support the <code>audio</code> element.
        </audio>


        <div class="alert alert-danger" v-if="!questions.length">
            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Δεν υπάρχουν ερωτήσεις.
        </div>

        <div class="clearfix margin-bottom-20" v-if="!testResults">
            <div class="pull-right">
                <button class="btn btn-circle  btn-sm"
                        :class="showCorrect ? 'blue' : 'btn-default'"
                        @click="toggleShowCorrect">
                    <i class="fa fa-check" aria-hidden="true"></i> Σωστές Απαντήσεις
                </button>
                <button class="btn btn-circle  btn-sm"
                        :class="shouldPlaySound ? 'blue' : 'btn-default'"
                        @click="toggleShouldPlaySound">
                    <i class="fa fa-volume-up" aria-hidden="true"></i> Εκφώνηση
                </button>
            </div>

        </div>

        <question-component v-for="question in questions"
                            :key="question.id"
                            :question="question"
                            :userSignedIn="userOptions.user_signed_in == true"
                            :showID="showID"
                            :showCorrect="showCorrect"
                            @playSound="playSound">

        </question-component>
    </div>
</template>

<script>
import QuestionComponent from "./Question.vue";
import {
  localStorageGet,
  localStorageSet
} from "./../../safe-local-storage.js";

export default {
  data() {
    return {
      questions: [],
      userOptions: {},
      showID: false,
      showCorrect: true,
      shouldPlaySound: false
    };
  },
  components: { QuestionComponent },
  props: ["questionList", "testResults"],
  methods: {
    playSound(sound, id) {
      if (!sound || !this.shouldPlaySound) return;
      this.$refs.audioPlayer.src = sound;
      this.$refs.audioPlayer.play();
      this.$refs.audioPlayer.onended = () => this.setCurrentlyPlaying(null);
      this.setCurrentlyPlaying(id);
    },
    setCurrentlyPlaying(id) {
      for (let question of this.questions)
        question.playing = question.id === id;
    },
    toggleShowCorrect() {
      this.showCorrect = !this.showCorrect;
      // localStorage.showCorrect = this.showCorrect;
      localStorageSet("showCorrect", this.showCorrect);
      this.questions.forEach(q => (q.tempSelectedOption = null));
    },
    toggleShouldPlaySound() {
      this.shouldPlaySound = !this.shouldPlaySound;
      // localStorage.shouldPlaySound = this.shouldPlaySound;
      localStorageSet("shouldPlaySound", this.shouldPlaySound);
    }
  },
  created() {
    this.showCorrect = localStorageGet("showCorrect")
      ? localStorageGet("showCorrect") === "true"
      : true;
    this.shouldPlaySound = localStorageGet("shouldPlaySound")
      ? localStorageGet("shouldPlaySound") === "true"
      : false;
    // if its the result screen, always show correct and play sound
    if (this.testResults) this.showCorrect = this.shouldPlaySound = true;

    if (this.questionList) {
      this.questions = this.questionList;
      // fix this, add for demo test
      this.userOptions.user_signed_in = true;
    } else {
      let data = JSON.parse(
        document.getElementById("json-container").dataset.questions
      );
      this.showID =
        document.getElementById("json-container").dataset.showId === "true";
      this.userOptions = data.user_options;
      this.questions = Question.parse(data, {
        removeExplanation: !this.userOptions.user_signed_in
      });
    }
  }
};
</script>